export class Conversation {
    conversationEnd: string;
    conversationId: string;
    conversationStart: string;
    divisionIds: Array<string>;
    originatingDirection: string;
    participants: Array<Participant>;
}
export class Participant {
    participantName: string;
    purpose: string;
    userId: string;
    sessions: Array<Session>;
    attributes?: { [key: string]: string; };
}
export class Session {
    ani: string;
    direction: string;
    dnis: string;
    edgeId: string;
    sessionId: string;
    peerId: string;
    mediaType: string;
    outboundCampaignId: string;
    outboundContactListId: string;
    outboundContactId: string;
    segments: Array<Segment>;
}
export class Segment {
    disconnectType: string;
    errorCode: string; // agergado
    segmentEnd: string;
    segmentStart: string;
    segmentType: string;
    wrapUpCode: string;
    wrapUpNote: string;
    properties: Array<Property>;
}
export class Property {
    property: string;
    propertyType: string;
    value: string;
}
